import { createSearchParams, getPageSlug } from "@Utils";
import { useHistory } from "react-router";

interface IUseActivityItemProps {
    isPublic?: boolean;
    userId: string;
}

const SLUGS = ["video-library"];

const useActivityItem = ({ userId }: IUseActivityItemProps) => {
    const history = useHistory();

    const handleActivitySelect = (currentActivityId: string) => {
        const slug = getPageSlug(location.pathname);
        const searchParams = createSearchParams({ activity: currentActivityId, user: userId });
        const url = `/${SLUGS.includes(slug) ? slug : "activity"}?${searchParams}`;
        history.push(url, { activity: currentActivityId });
    };

    return {
        handleActivitySelect,
    };
};

export default useActivityItem;
